import HTMLTemplate from './template.html'
import './styles.scss'

export const CountryRiskRatingPopupComponent = (() => {
    const vueComponent = {
        data() {
            return {
                leftPosition: 0,
                topPosition: 0,
                display: 'none',
                countryName: '',
                travelRiskRating: 0,
                medicalRiskRating: 0,
                enableTravelRisk: true,
                enableMedicalRisk: false
            }
        },
        template: HTMLTemplate
    }

    const DOMElement = document.getElementById('vue-travel-risk-country-rating-popup')
    if (DOMElement === null) {
        return null
    } else {
        return Vue.createApp(vueComponent).mount(DOMElement)
    }
})();
